import * as React from 'react'; 
import {bool, string} from 'prop-types';

export default function HabitCheckbox(props){

  const styleClass = [
    'inline-block',
    'rounded-full',
    'w-5', 
    'h-5',
  ];

  if(props.completed){
    styleClass.push(`bg-${props.color}`);
  } else {
    styleClass.push('bg-gray-400')
  }

  return <div className={styleClass.join(' ')}>
  </div>
}


HabitCheckbox.defaultProps = {
   completed: false,
   color: 'red-400'
}

HabitCheckbox.propTypes = {
   completed: bool,
   color: string,
}
